module.exports = __webpack_public_path__ + "img/goal-active.cb970926.svg";